import { Box, Button, Card, Radio, Stack, Typography } from '@mui/material';
import HeadingWithDescription from '../../components/headingWithDescription';
import { MachineDetails } from '../../types/manageAccount.type';
import { PRIMARY_COLOR } from '../../constants';
import { getProductImageByName } from '../../helpers/imageHelpers';
import { getFormattedDate } from '../../helpers/serviceHelpers';
import { OUT_OF_WARRANTY } from '../../constants/longStrings.constants';

export default function ChooseAppliance({
  setCurrentStep,
  setLoading,
  setSelectedMachine,
  machinesDetails,
  selectedMachine,
  showHeading = true,
}: {
  setCurrentStep: any;
  setLoading: any;
  setSelectedMachine: any;
  machinesDetails: MachineDetails[];
  selectedMachine: MachineDetails | null;
  showHeading: boolean;
}) {
  return (
    <Stack flex={1} gap={3} display={'flex'}>
      {showHeading && (
        <HeadingWithDescription
          heading="Choose Appliance"
          description="Select your IFB Appliance from the list below or add a new product if it's not listed."
        />
      )}
      <Box flex={1}>
        {machinesDetails.map((machinesDetail) => {
          const selected = selectedMachine?.zzr3ser_no === machinesDetail?.zzr3ser_no;
          return (
            <div key={machinesDetail.zzr3ser_no} onClick={() => setSelectedMachine(machinesDetail)}>
              <Card
                elevation={3}
                className="border-2"
                sx={{
                  borderColor: selected ? PRIMARY_COLOR : 'transparent',
                  borderRadius: 4,
                  my: 2,
                }}
              >
                <Box p={1}>
                  <Radio checked={selected} name="appliance" inputProps={{ 'aria-label': 'A' }} />
                  <Stack gap={0.5} mt={-6} alignItems={'center'}>
                    <img
                      alt={machinesDetail?.machine_type}
                      src={
                        machinesDetail?.prd_image_url ??
                        getProductImageByName(machinesDetail?.machine_type)
                      }
                      style={{ width: '150px', height: '150px', objectFit: 'contain' }}
                    />
                    {machinesDetail?.machine_status !== OUT_OF_WARRANTY ? (
                      <Typography variant="body2" color="secondary">
                        Warranty expires on:{' '}
                        <Typography
                          variant="body2"
                          fontWeight={'500'}
                          color="primary"
                          component={'span'}
                          sx={{ display: 'inline-block' }}
                        >
                          {getFormattedDate(machinesDetail?.warranty_edate)}
                        </Typography>
                      </Typography>
                    ) : (
                      <Typography variant="body2" color="secondary">
                        {OUT_OF_WARRANTY}
                      </Typography>
                    )}

                    <Typography variant="body2" color="secondary">
                      {machinesDetail?.zzr3ser_no}
                    </Typography>
                    <Typography variant="body1" fontWeight={'500'}>
                      IFB {machinesDetail?.machine_name}
                    </Typography>
                  </Stack>
                </Box>
              </Card>
            </div>
          );
        })}
        <Box height={100} />
      </Box>
      {selectedMachine && (
        <Button
          size="large"
          sx={{
            backgroundColor: 'black',
            py: 2,
            borderRadius: 3,
            position: 'fixed',
            bottom: '2%',
            left: '5%',
            width: '90%',
          }}
          variant="contained"
          disabled={!selectedMachine}
          onClick={() => setCurrentStep((x: any) => x + 1)}
        >
          Next
        </Button>
      )}
    </Stack>
  );
}
